export default __webpack_public_path__ + "static/media/landing.df9e5f69.gif";